import { memo } from 'react';
import { PropsWithChildren } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowImageClickable, ImageClickableProps } from '../../atoms';
import { ComposableContainer, ComposableBannerCardProps } from '../../composables';
import { NextImageType, PropsWithTestId } from '../../props';
import { PropsWithDataLayer } from '../../props';

export type CardBannerProps = ComposableBannerCardProps &
    PropsWithChildren &
    PropsWithTestId &
    PropsWithDataLayer & {
        image: ImageClickableProps;
        TagName?: NextImageType;
        classNames?: {
            container?: string;
            wrapper?: string;
        };
        href?: string;
        ariaLabel?: string;
    };

export const CardBanner: ComponentMemo<CardBannerProps> = memo(
    ({ children, image, TagName, button, classNames, href, ariaLabel, ...props }) => {
        return (
            <ComposableContainer.Root className={classNames?.container} {...props}>
                <ComposableContainer.Wrapper href={href} ariaLabel={ariaLabel} className={classNames?.wrapper}>
                    <GlowImageClickable TagName={TagName} {...button} {...image} />
                    {children}
                </ComposableContainer.Wrapper>
            </ComposableContainer.Root>
        );
    },
);

CardBanner.displayName = 'CardBanner';
